import { render, staticRenderFns } from "./SourEditMain.vue?vue&type=template&id=503d2c37&scoped=true&"
import script from "./SourEditMain.vue?vue&type=script&lang=js&"
export * from "./SourEditMain.vue?vue&type=script&lang=js&"
import style0 from "./SourEditMain.vue?vue&type=style&index=0&id=503d2c37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503d2c37",
  null
  
)

export default component.exports